import { pageDto } from "./pagedto";
import { AcademicFeePriceDto } from './academicfeepricedto';

export class AcademicFeePriceResponse {

    listAcademicFeePriceDto: AcademicFeePriceDto[] = [];

    pageDto: pageDto = new pageDto({});

}